import { last } from "lodash";
import { useEffect, useState } from "react";
import { getColorFromInitial } from "../../utils/Utils";
import { UserDetailModal } from "./UserDetailModal";
import { useImageLoader } from "../customHook/ImageLoader";
import { Avatar, Spin } from "antd";
import { UserStatusCustomAvatar } from "./UserStatusCustomAvatar";
import { useUserPresenceStore } from "../../store/useUserPresenceStore";

const MessageAvatar = ({
  person,
  size = 50,
  index,
  styleCss = { position: "absolute" },
}) => {
  const updateUserStatus = useUserPresenceStore(
    (state) => state.updateUserStatus,
  );
  const [brieftName, setBriefName] = useState();
  const [isOpenModalUserDetail, setIsOpenModalUserDetail] = useState(false);
  const { imageUrl, loading: isImageLoading } = useImageLoader(person?.avatar);

  const customStyleUserStatus = {
    borderRadius: "50%",
    position: "absolute",
    left: size === 40 ? "25px" : "32px",
    top: size === 40 ? "28px" : "38px",
    zIndex: 1,
    width: "14px",
    height: "14px",
    border: "2px solid white",
  };

  const handleOpenModalUserDetail = () => {
    setIsOpenModalUserDetail(true);
  };

  useEffect(() => {
    updateUserStatus(person?.userId, person?.online ? "ONLINE" : "OFFLINE");
    setBriefName(
      last(person?.name?.trim()?.split(" "))?.[0] ||
        last(person?.username?.trim()?.split(" "))?.[0] ||
        "U",
    );
  }, [person]);

  if (isImageLoading) {
    <Avatar
      style={{
        zIndex: 10 - index,
        width: size,
        height: size,
        borderRadius: "50%",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 15,
        color: "#fff",
        fontWeight: 500,
        userSelect: "none",
        ...styleCss,
      }}
      icon={<Spin></Spin>}
    ></Avatar>;
  }

  return (
    <>
      <div className={`relative`}>
        <Avatar
          style={{
            zIndex: 10 - index,
            width: size,
            height: size,
            borderRadius: "50%",
            backgroundColor: getColorFromInitial(brieftName),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 15,
            color: "#fff",
            fontWeight: 500,
            userSelect: "none",
            ...styleCss,
          }}
          size={size}
          src={imageUrl}
          className={"cursor-pointer"}
          onClick={handleOpenModalUserDetail}
        >
          {brieftName}
        </Avatar>
        <UserStatusCustomAvatar
          userId={person?.userId}
          customStyle={customStyleUserStatus}
        />
      </div>
      {isOpenModalUserDetail && (
        <UserDetailModal
          person={person}
          isOpen={isOpenModalUserDetail}
          handleCancel={() => setIsOpenModalUserDetail(false)}
        />
      )}
    </>
  );
};
export { MessageAvatar };
